import { render, staticRenderFns } from "./addEditDetail.vue?vue&type=template&id=a5bffd1e"
import script from "./addEditDetail.vue?vue&type=script&lang=js"
export * from "./addEditDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5bffd1e')) {
      api.createRecord('a5bffd1e', component.options)
    } else {
      api.reload('a5bffd1e', component.options)
    }
    module.hot.accept("./addEditDetail.vue?vue&type=template&id=a5bffd1e", function () {
      api.rerender('a5bffd1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/holidayConfiguration/cmp/addEditDetail.vue"
export default component.exports